<template>
  <div class="cartContent">
    <div class="cartInfo" v-if="isLogined">
        <table>
          <tr class="cartHead">
            <th class="allSelect">
              <el-checkbox v-model="isAllSelect" @change="allSelect"></el-checkbox>
            </th>
            <th class="productInfo" colspan="2">商品信息</th>
            <th class="productPrice">单价</th>
            <th class="productNum">数量</th>
            <th class="productTotal">总价</th>
            <th class="productOperate">操作</th>
          </tr>
          <tr v-for="(item,i) in currentCartList" :key="'product_'+i">
            <td> 
              <el-checkbox v-model="item.checked" :key="'select_'+i" @change="selectCart"></el-checkbox>      
            </td>
            <td class="productImage"><img @click="goodsDetails(item.productId)" :src="item.defaultImage"></td>
            <td class="productName">{{item.name}}({{item.specName}})</td>
            <td>￥{{Number(item.settlementPrice).toFixed(2)}}</td>
            <td><input type="number" v-model="item.num" @change="EditNum(item)"></td>
            <td>￥{{Number(item.settlementPrice*item.num).toFixed(2)}}</td>
            <td><span @click="cartdel(item.productId,item.specId,i)">删除</span></td>
          </tr>
        </table>
        <div class="cartfooter" v-if="currentCartList.length>0"> 
          <input class="batchDelBtn" type="button" value="删除" @click="batchDel">
          <input type="button" value="去结算" @click="checkout">
          <div class="cartAmount">￥{{Number(totalPrice).toFixed(2)}}</div>      
          <div class="payLabel">应付总额：</div>          
        </div>
        <div class="cartEmpty" v-else>
          <img src="http://img.static.knnnj.com/Default/93c14adb-3f6e-42d3-986e-2202a82eedc5.png">
          <div>您的购物车还是空的，赶紧去选购吧！</div>
        </div>
    </div>
    <div class="cartInfo1" v-else>
      <div @click="toLogin()">亲,请先登陆</div>
    </div>
  </div>
</template>
<style>
@import '../../styles/cart.css';
</style>
<script>
  import api from '@/api'
  import { getCartItems } from '@/api/cart'
  import { mapMutations, mapState } from 'vuex'
  import { getStore, setStore } from '@/utils/storage'

  export default {
    data () {
      return {
        totalPrice:0,
        isAllSelect:false,
        userId: 0,
        checkoutNow: '现在结算',
        submit: true,
        currentCartList:[],
      }
    },
    computed: {
      ...mapState(['isLogined']), 

    },
    methods: {
      toLogin() {
      this.$router.push({ name: 'userLogin' })
      },
      ...mapMutations([
        'INIT_BUYCART', 'EDIT_CART', 'REDUCE_CART'
      ]),
      message (m) {
        this.$message.error({ message: m })
      },
      batchDel()
      {
        var delItem = this.currentCartList.find((p) => p.checked);
        if(!delItem)
        {
          this.$message({ message: '请选择要删除的商品', type: 'error', customClass: 'c-msg' })         
          return;
        }
        var delList = [];
        for(var i=0;i<this.currentCartList.length;i++)
         {
             if(this.currentCartList[i].checked)
             {
               delList.push({productId:this.currentCartList[i].productId,specId:this.currentCartList[i].specId})
             }
         }
         var _this=this;
         if(delList.length>0)
         {  
           api.post('api/services/app/FrontendCarts/BatchReducingCarts', { cartList:delList }).then(res => {
            if(res.data.success){
              this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })     
              _this._getCartItems() 
            } 
          })           
         }
      },
      allSelect()
      {
        this.totalPrice=0;
         for(var i=0;i<this.currentCartList.length;i++)
         {
             if(this.isAllSelect)
             {
               this.currentCartList[i].checked=true;
               this.$set(this.currentCartList[i],'checked',true)
               this.totalPrice += this.currentCartList[i].num*this.currentCartList[i].settlementPrice;
             }
             else
             {
               this.$set(this.currentCartList[i],'checked',false)
             }
         }
      },
      selectCart()
      {
        debugger;
        this.totalPrice=0;
        for(var i=0;i<this.currentCartList.length;i++)
         {
             if(this.currentCartList[i].checked)
             {
             
               this.totalPrice += this.currentCartList[i].num*this.currentCartList[i].settlementPrice;
             }            
         }
      },
      goodsDetails (id) {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },

      // 修改购物车
      _cartEdit (productId, num, specId) {
        this.EDIT_CART({
            productId,
            num,
            specId
          })
      },
     
      EditNum (row) { // 数量        
        if(row.num==''||row.num==undefined|| parseInt(row.num)<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          row.num=1;
          return;
        }
        if(parseInt(row.num)>parseInt(row.stock))
        {
          this.$message({ message: '数量不得大于库存:'+row.stock, type: 'error', customClass: 'c-msg' }) 
          row.num=1;
          return;
        }
        this._cartEdit(row.productId, parseInt(row.num), row.specId)
        this.selectCart();
      },
      // 删除整条购物车
      cartdel (productId, specId,i) {       
        //this.REDUCE_CART({productId, specId})
        //this.currentCartList.splice(i,1);
        let p = {
          productId,
          specId
        }
        api.post('api/services/app/FrontendCarts/ReducingCarts',p).then(res => {
          if(res.data.success){
            this.currentCartList.splice(i, 1)
            setStore('buyCart', this.currentCartList)
            this.selectCart();
            this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })      
          } 
        })
      
      },
      checkout () {
        this.checkoutNow = '结算中...'
        this.submit = false
        let cartlist = []
        this.currentCartList.forEach(item => {
          if (item.checked) {
            cartlist.push(item)
          }
        })
        if(cartlist.length==0)
        {
          this.$message({ message: '请选择要结算的商品', type: 'error', customClass: 'c-msg' })
          return;
        }
        var buyCart = setStore('cartlist',cartlist)
        this.$router.push({path: 'checkout', query: {isCart: true}})        
      },

      async _getCartItems()
      {               
        var _this=this;
        await getCartItems().then(function(res){        
        if(res.data.success){
          _this.currentCartList = res.data.result.items      
          _this.totalPrice = 0.00;
          for(var i=0;i<_this.currentCartList.length;i++)
          {
            _this.currentCartList[i].checked=true;
            _this.totalPrice += _this.currentCartList[i].num*_this.currentCartList[i].settlementPrice;
            _this.$set(_this.currentCartList[i],'checked',true)
          }
          // setStore('buyCart', _this.currentCartList)
        }
        }).then(this.INIT_BUYCART)
      }
    },
    mounted () {     
      if(this.isLogined)
      {
        this._getCartItems();     
      }
    },
    components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?31a35ec2